module.exports = __webpack_public_path__ + "img/dark_cabin_bag.ba944493.png";